import request from './request'

// 请求参数接口
export interface ChecklistDetailParams {
  id: number
}

// Checklist 组件项接口（对应后端的 components 数组元素）
export interface ChecklistComponent {
  component: string
  component_zh: string
  values: string[]
  values_zh: string[]
  field_type: string
  field_type_text: string
  field_type_text_zh: string
  sort: number
}

// Checklist 值容器接口（对应后端的 values 和 checklist_values 对象）
export interface ChecklistValueContainer {
  components: ChecklistComponent[]
}

// Checklist 详情数据接口（完整后端字段）
export interface ChecklistDetailData {
  id: number
  item_id: string
  item_name: string
  item_name_zh: string
  type: string
  type_text: string
  type_text_zh: string
  section: string
  section_zh: string
  duration_minutes: number
  duration_text: string
  duration_text_zh: string
  seasons: string[]
  seasons_zh: string[]
  frequency: string
  frequency_zh: string
  photo_required: number
  follow_up_needed: number
  follow_up_care_plans: string[]
  follow_up_care_plans_text: string[]
  follow_up_care_plans_text_zh: string[]
  plan_values: {
    essential_care: number
    enhanced_care: number
    premium_care: number
  }
  values: ChecklistValueContainer
  checklist_values: ChecklistValueContainer
  follow_up_text: string
  follow_up_text_zh: string
  icon_url: string
  description: string
  description_zh: string
  sort: number
  status: number
  status_text: string
  status_text_zh: string
  create_time: string
  update_time: string
}

// API 响应接口
export interface ChecklistDetailResponse {
  code: number
  msg: string
  data: ChecklistDetailData
}

// 获取 Checklist 详情
export function getChecklistDetail(
  params: ChecklistDetailParams,
): Promise<ChecklistDetailResponse> {
  return request.post('/api/admin/checklist/detail', params)
}
